(function () {
  const DEBUG = false;
  const processed = new WeakSet();

  function parsePrice(text) {
    if (!text) return NaN;
    let s = String(text).replace(/\s/g, "");
    s = s.replace(/[^\d.,-]/g, "");
    if (s.indexOf(",") > -1 && s.indexOf(".") > -1) {
      if (s.lastIndexOf(",") < s.lastIndexOf(".")) {
        s = s.replace(/,/g, "");
      } else {
        s = s.replace(/\./g, "").replace(",", ".");
      }
    } else {
      s = s.replace(",", ".");
    }
    const n = parseFloat(s);
    return isNaN(n) ? NaN : n;
  }

  function formatPrice(num) {
    return (
      Number(num).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + "TL"
    );
  }

  function addExtraDiscount() {
    document.querySelectorAll(".price.price--on-sale").forEach((priceBox) => {
      if (priceBox.closest("cart-recommendations")) return;
      if (processed.has(priceBox)) return;

      // quick-view veya en yakın kapsayıcıdaki data-product-tags’i bul
      const quickView = priceBox.closest("li")?.querySelector("quick-view");
      const tagsAttr = quickView?.getAttribute("data-product-tags");
      if (!tagsAttr) return;

      const tags = tagsAttr.split(",").map((t) => t.trim().toLowerCase());

      if (!tags.includes("outlet")) return; // outlet yoksa atla

      processed.add(priceBox);

      const salePriceEl =
        priceBox.querySelector(".price-item--sale bdi") ||
        priceBox.querySelector(".price-item--sale");
      if (!salePriceEl) return;

      const salePrice = parsePrice(
        salePriceEl.textContent || salePriceEl.innerText
      );
      if (isNaN(salePrice)) return;

      const discounted = salePrice * 0.8;

      const discountDiv = document.createElement("div");
      discountDiv.className = "extra-discount-info";
      discountDiv.style.color = "#e6e8dc";
      discountDiv.style.background = "#556360";
      discountDiv.style.fontWeight = "600";
      discountDiv.style.marginTop = "5px";
      discountDiv.style.fontSize = "13px";
      discountDiv.style.letterSpacing = "normal";
      discountDiv.style.padding = "5px";
      discountDiv.style.borderRadius = "4px";
      discountDiv.textContent = `Sepette %20 indirim: ${formatPrice(
        discounted
      )}`;

      priceBox.style.display = "flex";
      priceBox.style.flexDirection = "column";
      priceBox.appendChild(discountDiv);
    });
  }

  // ilk çalıştırma ve observer
  addExtraDiscount();
  setInterval(addExtraDiscount, 1000);

  const observer = new MutationObserver(addExtraDiscount);
  observer.observe(document.body, { childList: true, subtree: true });
})();
